import { onMounted, ref } from 'vue';
import type { BonusLootTier } from '@/types/api';
import { fetchBonusLootTiers } from '@/lib/apiClient';
import { rollBonusLoot } from '@/lib/bonusLoot';
import { useAuth } from '@/composables/useAuth';

const REFRESH_MS = 30_000;

export function useBonusLoot() {
  const { token } = useAuth();
  const tiers = ref<BonusLootTier[]>([]);
  const loading = ref(false);
  let lastLoadedAt = 0;

  async function load(force = false) {
    if (!token.value) return;
    if (!force && tiers.value.length > 0 && Date.now() - lastLoadedAt < REFRESH_MS) {
      return;
    }

    loading.value = true;
    try {
      tiers.value = (await fetchBonusLootTiers(token.value)).tiers;
      lastLoadedAt = Date.now();
    } finally {
      loading.value = false;
    }
  }

  async function roll(): Promise<number> {
    await load(true);
    return rollBonusLoot(tiers.value);
  }

  onMounted(() => {
    void load(true);
  });

  return {
    tiers,
    loading,
    load,
    roll,
  };
}
